import { CompanyDetails } from "modules/deliveryCompanies";

const CompanyInfoPage = () => {
  return <CompanyDetails />;
};

export default CompanyInfoPage;
